import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-input-close",
  "use": "icon-input-close-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-input-close\">\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\n<g><path d=\"M846.5,153.5c-191.4-191.4-501.6-191.4-693,0c-191.4,191.4-191.4,501.6,0,693c191.4,191.4,501.6,191.4,693,0C1037.8,655.1,1037.8,344.9,846.5,153.5z M777.2,707.9l-69.3,69.3L500,569.3L292.1,777.2l-69.3-69.3L430.7,500L222.8,292.1l69.3-69.3L500,430.7l207.9-207.9l69.3,69.3L569.3,500L777.2,707.9z\" /></g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/input-close.svg
// module id = jXRZ
// module chunks = 76